import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import { http } from '../../AxiosConfig'
import FormLoader from '../FormLoader/FormLoader'

// TODO: curency formatter
// TODO: date formatter
// TODO: picture display for recite
const StatusCard = () => {
  const [reimbursement, setReimbursement] = useState(null)
  const params = useParams()

  useEffect(() => {
    fetchReimburstmet()
  }, [])

  // const dateFormatter =(date)=>{
  //   return format(new Date(date), 'M/dd/yyyy')
  // }
  const currency = new Intl.NumberFormat(
    'en-US',
    {
      style: 'currency',
      currency: 'USD',
    },
  )

  function reimbursementNameFormatter(name) {
    return name
      .split('_')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join(' ')
  }
  function fetchReimburstmet() {
    http
      .get(`/reimbursements/${params.reimbursementId}`)
      .then(res => {
        setReimbursement(res.data.data.attributes)
      })
      .catch(err => {
        toast.error(`Could not find a item.${err.message}`)
      })
  }
  const numericalStatus = () => {
    const values = { pending: 0, submitted: 33, approved: 66, paid: 100 }

    return values[reimbursement.status]
  }
  if (!reimbursement) {
    return (
      <div className="mt-5 card">
        <FormLoader message="Updating" />
      </div>
    )
  }
  return (
    <div className="card mobile-size">
      <Toaster position="top-center" reverseOrder={false} />
      <h1 className='className="text-2xl'>Welcome Back</h1>
      <h1 className="text-2xl">{reimbursement?.user?.full_name}</h1>
      <div>Payback total:{currency.format(reimbursement.repay_total)}</div>
      {reimbursement?.reimbursement_items?.map(current => (
        <div key={current.id} className="card mt-5 mb-5">
          <div key={current.id} className="capitalize">
            {reimbursementNameFormatter(current.type)}
          </div>
          <div>{current.name}</div>
          <div>Your reimbursement status is</div>
          <div>
            <strong className="text-green-400">{reimbursement.status}</strong>
          </div>
          <progress value={numericalStatus()} max="100"></progress>
          <div>
            Last updated &nbsp;
            {new Date(reimbursement.updated_at).toDateString(
              'en-US',
              {
                timeZone: 'UTC',
              },
            )}
          </div>
        </div>
      ))}
      <div></div>
    </div>
  )
}
export default StatusCard
